/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherUmbrellaIcon16Solid = forwardRef('WeatherUmbrellaIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.875 1.25a.875.875 0 1 0-1.75 0v.754a7.004 7.004 0 0 0-6.04 5.853A.992.992 0 0 0 2.068 9h5.057v3.75a.625.625 0 1 1-1.25 0 .875.875 0 0 0-1.75 0 2.375 2.375 0 0 0 4.75 0V9h5.057a.992.992 0 0 0 .983-1.143 7.004 7.004 0 0 0-6.04-5.853V1.25Z" })));
});
